import Client from "@walletconnect/sign-client"
import { SessionTypes } from "@walletconnect/types"

interface Options {
    client: Client
    session: SessionTypes.Struct
}

class WalletConnectSendTransaction {
    private client: Client
    private session: SessionTypes.Struct

    constructor({ client, session }: Options) {
        this.client = client
        this.session = session
    }
    
    eth(params: any, chainId: string): Promise<void> {
        return this.client.request({
            chainId,
            topic: this.session.topic,
            request: {
                method: "eth_sendTransaction",
                params
            }
        })
    }
    tron() { }
    put(params: any, chainId: string) {
        return this.client.request({
            chainId,
            topic: this.session.topic,
            request: {
                method: "put_signAndSendTransaction",
                params
            }
        })
    }
    solana(params: any, chainId: string) {
        return this.client.request({
            chainId,
            topic: this.session.topic,
            request: {
                method: "",
                params
            }
        })
    }
}

export default WalletConnectSendTransaction
export { WalletConnectSendTransaction }

